import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { createColumnHelper } from '@tanstack/react-table'

import Table, { TableProps } from '@/components/ui/tables/Table'

export type AccountData = {
  id: string
  name: string
  status: string
}

export type AccountSelectionTableProps = Pick<TableProps<AccountData>, 'data' | 'onSelectRow' | 'selectedRows' | 'selectable'>

const columnHelper = createColumnHelper<AccountData>()

export function AccountSelectionTable(props: AccountSelectionTableProps) {
  const { t } = useTranslation()

  const columns = useMemo(
    () => [
      columnHelper.accessor('name', {
        header: t('table.accountSelection.header.name').toString(),
      }),
      columnHelper.accessor('status', {
        header: t('table.accountSelection.header.status').toString(),
      }),
    ],
    [t]
  )

  return <Table {...props} container="div" columns={columns} />
}

export default AccountSelectionTable
